import request from "../utils/request";

export const uploadAsset = async (data) => {
    return await request.post("/assetupload", data);
};



// WEBPACK FOOTER //
// ./src/api/assetUpload.js